import * as actionTypes from '../types/inputReadyProducts';

export function inputReadyProducts(payload) {
  return {
    type: actionTypes.INPUT_READY_PRODUCTS,
    payload
  };
}
export function inputReadyProductsSuccess(payload) {
  return {
    type: actionTypes.INPUT_READY_PRODUCTS_SUCCESS,
    payload
  };
}
export function inputReadyProductsFail(payload) {
  return {
    type: actionTypes.INPUT_READY_PRODUCTS_FAIL,
    payload
  };
}

export function updateReadyProducts(payload) {
  return {
    type: actionTypes.UPDATE_READY_PRODUCTS,
    payload
  };
}
export function updateReadyProductsSuccess(payload) {
  return {
    type: actionTypes.UPDATE_READY_PRODUCTS_SUCCESS,
    payload
  };
}
export function updateReadyProductsFail(payload) {
  return {
    type: actionTypes.UPDATE_READY_PRODUCTS_FAIL,
    payload
  };
}

export function setMarkField(payload) {
  return {
    type: actionTypes.SET_MARK,
    payload
  };
}
export function setNormativeDocField(payload) {
  return {
    type: actionTypes.SET_NORMATIVE_DOC,
    payload
  };
}
export function setOperationNumIdField(payload) {
  return {
    type: actionTypes.SET_OPERATION_NUM_ID,
    payload
  };
}
export function setPieceIdField(payload) {
  return {
    type: actionTypes.SET_PIECE_ID,
    payload
  };
}
export function setPieceNumIdField(payload) {
  return {
    type: actionTypes.SET_PIECE_NUM_ID,
    payload
  };
}
export function setProfileSizeField(payload) {
  return {
    type: actionTypes.SET_PROFILE_SIZE,
    payload
  };
}
export function setQcDateField(payload) {
  return {
    type: actionTypes.SET_QC_DATE,
    payload
  };
}
export function setQcIdField(payload) {
  return {
    type: actionTypes.SET_QC_ID,
    payload
  };
}
export function setQtyField(payload) {
  return {
    type: actionTypes.SET_QTY,
    payload
  };
}
export function setThicknessField(payload) {
  return {
    type: actionTypes.SET_THICKNESS,
    payload
  };
}
export function setQuantityField(payload) {
  return {
    type: actionTypes.SET_QUANTITY,
    payload
  };
}

export function setQuantityOffField(payload) {
  return {
    type: actionTypes.SET_QUANTITY_OFF,
    payload
  };
}

export function setZdvlLineIdField(payload) {
  return {
    type: actionTypes.SET_ZDVL_LINE_ID,
    payload
  };
}
export function setZdvlLineNumIdField(payload) {
  return {
    type: actionTypes.SET_ZDVL_LINE_NUM_ID,
    payload
  };
}
export function setLengthField(payload) {
  return {
    type: actionTypes.SET_LENGTH,
    payload
  };
}

export function addInputPiece(payload) {
  return {
    type: actionTypes.ADD_INPUT_PIECE,
    payload
  };
}

export function setInputProductsPieces(payload) {
  return {
    type: actionTypes.SET_INPUT_PRODUCTS_PIECES,
    payload
  };
}
export function setProductUnit(payload) {
  return {
    type: actionTypes.SET_READY_UNIT,
    payload
  };
}
export function setReadyPlantOperationAttribsInherit(payload) {
  return {
    type: actionTypes.SET_READY_ATTRIBS_INHERIT,
    payload
  };
}
